import sections, { availableSections, Section } from 'app/components/OrgsList/OrgsSettings/sections'
import { OrgSettingsHistoryProvider } from 'app/dataProviders/OrgSettingsHistoryProvider'
import * as orgsTypes from 'app/common/constants/schools/types'
import { OrgId } from 'app/common/types/id'

import General from './General'
import Limits from './Limits'
import { SellPointsComponent } from './SellPoints'
import Requests from './Requests'
import Subsidies from './Subsidies'
import Cafeteria from './Cafeteria'
import HistoryFilterProvider from './HistoryLink/filters/HistoryFilterProvider'
import { Reports } from './Reports'
import { DietFood } from './DietFood'

type Props = {
  type?: string
  orgId: number
  orgType: (typeof orgsTypes)[keyof typeof orgsTypes]
  option?: string
  basePath: string
}

const ContentView = ({ type, orgId, orgType, option, basePath }: Props) => {
  // $FlowFixMe
  const section = availableSections.includes(type as Section) ? type : undefined

  return (
    <HistoryFilterProvider orgId={orgId} section={section}>
      {(filterParams) => (
        <OrgSettingsHistoryProvider {...filterParams}>
          {type === sections.ORGS_SETTINGS_GENERAL && (
            <General orgId={String(orgId)} orgType={orgType} />
          )}
          {type === sections.ORGS_SETTINGS_LIMITS && <Limits orgId={orgId} />}
          {type === sections.ORGS_SETTINGS_SELLPOINTS && (
            <SellPointsComponent
              orgId={orgId}
              option={option}
              basePath={basePath}
            />
          )}
          {type === sections.ORGS_SETTINGS_SUBSIDIES && <Subsidies orgId={orgId} />}
          {type === sections.ORGS_SETTINGS_DIET_FOOD && <DietFood orgId={orgId} />}
          {type === sections.ORGS_SETTINGS_REPORTS && <Reports orgId={String(orgId) as OrgId} />}
          {type === sections.ORGS_SETTINGS_REQUESTS && <Requests orgId={orgId} orgType={orgType} />}
          {type === sections.ORGS_SETTINGS_CAFETERIA && <Cafeteria orgId={orgId} />}
        </OrgSettingsHistoryProvider>
      )}
    </HistoryFilterProvider>
  )
}

export default ContentView
